import { RichText } from "../model/viewModel/richText";

const defaultStyle: React.CSSProperties = {
  fontFamily: "Arial",
  fontSize: "14px",
  color: "black",
};

export const getDefaultStyle = (): React.CSSProperties => {
  return { ...defaultStyle };
};

export const getRichTextFont = (richText: RichText): string => {
  return `${richText.bold ? "bold " : ""}${richText.italic ? "italic " : ""}${richText.fontSize ?? defaultStyle.fontSize} ${defaultStyle.fontFamily}`;
};

export const getRichTextStyle = (richText: RichText): React.CSSProperties => {
  return {
    whiteSpace: "pre",
    fontFamily: defaultStyle.fontFamily,
    fontSize: richText.fontSize ?? defaultStyle.fontSize,
    color: richText.color ?? defaultStyle.color,
    fontWeight: richText.bold ? "bold" : "normal",
    fontStyle: richText.italic ? "italic" : "normal",
    textDecoration:
      richText.strikethrough && richText.underline
        ? "underline line-through"
        : richText.strikethrough
          ? "line-through"
          : richText.underline
            ? "underline"
            : "none",
  };
};
